import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/pasme/zivalPasmaIzracun";

export const triggerBreedCalculation = createAsyncThunk(
  "breedCalculation/trigger",
  async (species, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(
        `${baseUrl}/preracunDelezevPasemVsehZivali`,
        {
          species,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const breedCalculationSlice = createSlice({
  name: "breedCalculation",
  initialState: {},
  reducers: {},
});

export default breedCalculationSlice.reducer;
